import * as React from "react";
import "../proposols/step1/proposol.css";
import { useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector,} from "react-redux";
import { set_info3 } from "../../Redux/action";
import {  Col, Form,Input, Row,Button,DatePicker,Switch,Select} from "antd/lib";
import Showvehicle from "../proposols/step3/Showvehicle";
// import { financierList } from "../../../Redux/actions/NumBikeation";
import { financierList } from "../../Redux/actions/NumCaration";
import moment from "moment";

function ProposalCarinfo({setShowStep4,showStep4,setShowStep5,showStep5,Ref4}) {
  // console.log("step444",showStep5)
  const [form] = Form.useForm();
  const [formLayout] = useState('vertical');
  const Quotepost = useSelector((state) => state?.vehicledetail?.quickQuotePost);
  const QuickQuoteInput = useSelector((state) => state?.vehicledetail?.quoteInput)
  const QuoteCarpost = useSelector((state) => state?.cardetail?.quickQuotePost);

  const vehicledetail = useSelector((state) => state?.common?.vahanData);
  // console.log(vehicledetail)
  const EngData = useSelector((state) => state.addressdetail.info3);
  // console.log(EngData)
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [Financed, setFinanced] = useState(EngData?.financed === 'YES' ? 'YES' : 'NO');
  const [financiers, setFinanciers] = useState([])

useEffect(()=> {
  dispatch(financierList())
  .then((res) => {
    //let array = []
    // console.log('financierList',res);
    const namesArray = Object.values(res);
    // console.log(namesArray);
        // console.log("resp", makeData);
    setFinanciers(namesArray)
  })
},[])

// console.log(financiers)
// console.log(typeof (financiers))
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ bikeNumber: e.target.value }); 
  };
  const handleAddress = (e) => {
    // console.log(e)
    setFinanced(e ? 'YES' : 'NO');
  }
  // console.log(Financed)
  const onFinish = (values) => {
    setLoading(true)
    // console.log(values)
    var data = {
      Engine: values.Engine,
      Chasis: values.Chasis,
      bikeNumber: values.bikeNumber,
      financed: Financed,
      registrationYear:moment(values.registrationYear).format('YYYY-MM-DD'),
      Financer: values.Financer ? values.Financer : null,
      agreementType: values.agreementType ? values.agreementType : null,
      FinancerCity: values.FinancerCity
    }
    // console.log(data)
    dispatch(set_info3(data))
    setTimeout(()=>{
      setLoading(false)
      {QuickQuoteInput?.insuranceProductCode === 'Not_Secure' ?
      setShowStep4(true) : 
      setShowStep5(true)
       }
      Ref4.current?.scrollIntoView({ behavior: "smooth" });
      //history.push("/login");
      },500)
  }
  const onFinishFailed = (values) => {
    console.log(values)
    form.scrollToField(values.errorFields[0].name);
  }
  const handleSearchFinance = (searchText) => {
    const filteredOptions = financiers.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    setFinanciers(filteredOptions);
  };
  return (
    <>
    {showStep4 || showStep5? 
      <Showvehicle/>
     :
     <div className="gridparent-skb">
     <Form
         layout={formLayout}
         form={form}
         style={{paddingTop: "10px"}}
         requiredMark={false}
         onFinish={onFinish}
         onFinishFailed={onFinishFailed}
         >
           <Row gutter={24}>
           <Col span={12}>
           <Form.Item
              label="Vehicle Registration No."
              name='bikeNumber'
              rules={[
                {
                  pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                  message: 'Invalid Vehicle No',
                },
                { required: true, message: 'Enter Vehicle No' },
              ]}
              initialValue={Quotepost?.licensePlateNumber ? Quotepost?.licensePlateNumber : QuoteCarpost?.licensePlateNumber ? QuoteCarpost?.licensePlateNumber : ''}
              >
              <Input
              onChange={handleInputChange}
              placeholder="Enter Vehicle Number (eg. DL1SAB1234)">
              </Input>
            </Form.Item>
           </Col>
         <Col span={12}>
           <Form.Item 
             label="Engine Number"
             name='Engine'
             rules={[
               { required: true, message: 'Enter Engine Number' },
             ]}
             initialValue={vehicledetail?.vehicle_engine_number}
             >
            <Input placeholder="Enter Engine Number">
            </Input>
             </Form.Item>
           </Col>
         </Row>
         <Row gutter={24}>
         <Col span={12}>
           <Form.Item 
              label="Registration Year"
              name='registrationYear'
              rules={[{
              required: true, 
              message: 'please input Registration Year'
              }]}
              initialValue={vehicledetail?.registration_date ? moment(vehicledetail?.registration_date) : null}
              >
              <DatePicker
                style={{width: "100%", padding: "8px"}}
                format="YYYY-MM-DD"
                //onChange={onDateChange}
                placeholder="Select Registration Date"
              />
            </Form.Item>
           </Col>
         <Col span={12}>
           <Form.Item 
             label="Chasis Number"
             name='Chasis'
             rules={[
               { required: true, message: 'Enter Chasis Number' },
             ]}
             initialValue={vehicledetail?.vehicle_chasi_number ? vehicledetail?.vehicle_chasi_number : EngData?.Chasis}
             >
            <Input placeholder="Enter Chasis Number">
             </Input>
             </Form.Item>
           </Col>
         </Row>
         <Row gutter={24}>
         <p className="sameAddrrs">Is your Vehicle Financed? 
          <span>No </span>
          <Switch size="small" onChange={handleAddress} defaultChecked={EngData?.financed ==="YES"}/>
          <span> Yes</span>
          </p>
         </Row>
         {Financed === "YES" ? (
          <Row gutter={24}>
            <Col span={12}>
            <Form.Item
              name="Financer"
              label="Select Financer"
              rules={[{
                  required: true,
                  message: 'Please select Financer',
              }]}
                initialValue={EngData?.Financer}
              >
                <Select
                  defaultValue="Search for a Financer"
                  showSearch
                  // filterOption={(input, option) =>
                  //   option.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  // }
                  options={financiers?.map((option, index) => ({
                    key: index,
                    value: option,
                  }))}
                  onSearch={handleSearchFinance}
                />
            </Form.Item>
            </Col>
            <Col span={12}>
            <Form.Item
              name="agreementType"
              label="Financer agreement type"
              rules={[{
                  required: true,
                  message: 'Please select agreement type',
              }]}
                initialValue={EngData?.agreementType}
              >
                <Select
                  defaultValue="Select"
                  options={[
                    {
                      label: 'Hypothecation',
                      value: 'Hypothecation',
                    },
                  ]}
                />
            </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Financer (City/Branch)"
                name='FinancerCity'
                rules={[{
                required: true, 
                message: 'please input City/Branch'
                }]}
                initialValue={EngData?.FinancerCity}
                >
                <Input
                  style={{width: "100%"}}
                  placeholder="City/Branch" 
                />
                </Form.Item>
              </Col>
          </Row>
         ): null}
         <Row gutter={24}>
         <Col span={24}>
           <Form.Item style={{textAlign: "center"}}>
             <Button loading={loading}
               type="primary" 
               style={{background: "#293890",border: "#293890"}}
               htmlType="submit">
               Proceed
             </Button>
           </Form.Item>
         </Col>
         </Row>
     </Form>
    </div>
    }
    </>
  );
}

export { ProposalCarinfo };
